import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AlarmClockSvg = function AlarmClockSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.089 3.506 3.022 7.508 2 6.502 6.067 2.5zM16.911 3.506l4.067 4.002L22 6.502 17.933 2.5zM12.723 12.074V8.339h-1.446v5.157h3.886v-1.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.07a8.93 8.93 0 0 0-6.262 2.553 8.65 8.65 0 0 0-2.594 6.162c0 2.311.933 4.528 2.594 6.163A8.93 8.93 0 0 0 12 21.5a8.93 8.93 0 0 0 6.262-2.552 8.65 8.65 0 0 0 2.594-6.163 8.65 8.65 0 0 0-2.594-6.162A8.93 8.93 0 0 0 12 4.07M6.76 7.63A7.47 7.47 0 0 1 12 5.493c1.965 0 3.85.768 5.24 2.136a7.23 7.23 0 0 1 2.17 5.156c0 1.934-.78 3.789-2.17 5.156A7.47 7.47 0 0 1 12 20.077a7.47 7.47 0 0 1-5.24-2.136 7.23 7.23 0 0 1-2.17-5.156c0-1.934.78-3.789 2.17-5.156",
    clipRule: "evenodd"
  }));
};
export var AlarmClock = function AlarmClock(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AlarmClockSvg
  }));
};